import React from "react";
import { useTranslation } from "react-i18next";
import AgentManagementPage from "layouts/shared/AgentManagementPage";

function AgentManagementSP() {
  const { t } = useTranslation("agentManagement");
  return <AgentManagementPage title={t("titleSp")} />;
}

export default AgentManagementSP;
